import styled from 'styled-components'

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const ChipsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;
`

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`
